export const styles = {
	fileFormUpload: {
		position: 'absolute',
	},
	dragFileElement: {
		position: 'absolute',
		top: '0',
		left: '0',
		right: '0',
		bottom: '0',
		width: '100%',
		height: '100%',
		borderRadius: '1rem',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	labelFileUpload: {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	dragActiveStyle: {
		// borderWidth: '2px',
		// borderRadius: '1rem',
		// borderStyle: 'dashed',
		// borderColor: '#cbd5e1',
		// backgroundColor: 'rgba(204,202,202,0.32)',
	},
};
